import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

interface ColumnSizeState {
  columnSize: number;
}

const initialState: ColumnSizeState = {
  columnSize: 3
};

const gdprColumnSizeSlice = createSlice({
  name: 'gdprColumnSize',
  initialState,
  reducers: {
    setColumnSize(state, action: PayloadAction<number>) {
      state.columnSize = action.payload;
    }
  }
});

export const { setColumnSize } = gdprColumnSizeSlice.actions;
export const selectColumnSize = (state: RootState) => state.gdprColumnSize.columnSize;
export const gdprColumnSizeReducer = gdprColumnSizeSlice.reducer;
